


































































import { Vue, Component } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";
import { busy, db, IVIPDocument, VIPDocument, ICapabilities, auth, toaster, VIPDocumentRest } from "@/loader";
import DocumentEdit from "../../component/document/DocumentEdit.vue";

@Component({
	components: {
		DocumentEdit,
	}
})
export default class Documents extends Vue {
	public document: VIPDocument | null = null;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get documents(): VIPDocument[] {
		return db.documents.list.filter(x => !!x.id).sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
	}

	public get cap(): ICapabilities  {
		return auth.user?.capabilities || {};
	}

	public get href() {
		return this.document?.documentUrl(auth.token) || "";
	}

	public get fields() {
		return [
			{
				key: "name",
				label: "Nom",
				sortable: true,
			},
			{
				key: "categoryName",
				label: "Catégorie",
				sortable: true,
			},
			{
				key: "date_expiration",
				label: "Date d'expiration",
				sortable: true,
				class: "text-center",
			},
			{
				key: "actions",
				label: "Actions",
				class: "text-right",
			},
		]
	}

	public select(document: VIPDocument | null) {
		this.document = document;
		this.$bvModal.show("doc_modal")
	}

	public create() {
		let data: IVIPDocument = {
			id: db.documents.list.nextNewId(),
			name: "Nouveau Document",
		};
		this.select(db.documents.insert(data));
	}

	public modalClosed(event: BvModalEvent) {
		if (event.trigger !== "ok" && event.trigger !== "cancel" && this.document && this.document.id < 0) {
			db.documents.remove(this.document, true);
			this.document = null;
		}
	}

	public preview(document: VIPDocument) {
		this.document = document;
		this.$bvModal.show("preview_modal")
	}

	public remove(item: VIPDocument) {
		if (!this.cap.delete_vip_document) {
			toaster.toast({
				message: "Vous n'avez pas les droits pour supprimer un document.",
				variant: "warning",
			});
			return;
		}

		busy.start("Suppression du document ...");
		VIPDocumentRest.delete(item, { force: true }).then(result => {
			if (result.success) {
				toaster.toast({
					message: "Le document a été supprimée avec succès.",
					variant: "success",
					noAutoHide: false,
				});
				this.$forceUpdate();
				this.$emit("removed", item);
			}
		}).finally(() => {
			busy.stop();
		});
	}

	public mounted() {
		VIPDocumentRest.list({ per_page: 0 });
	}
}
